module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-BlackOblique.58af3caf.woff2";